import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { getSupplierOrderNumberTakenMessage, type SupplierOrderNumberTaken } from '../supplierOrderErrorMessages';

interface SupplierOrderNumberTakenHelpProps {
  taken: SupplierOrderNumberTaken;
}

/**
 * Field message of the ZD „Edytuj numer” when another ZD already has the number
 * (400 SUPPLIER_ORDER_NUMBER_TAKEN). Twin of OrderNumberTakenHelp: the number
 * links to that ZD in a new tab; without `supplierOrderId` it is plain text.
 */
const SupplierOrderNumberTakenHelp: React.FC<SupplierOrderNumberTakenHelpProps> = ({ taken }) => {
  const { t } = useTranslation(['orders']);
  if (taken.number && taken.supplierOrderId) {
    return (
      <Trans
        t={t}
        i18nKey="orders:supplierOrders.detail.numberTakenLinked"
        values={{ number: taken.number }}
        components={{
          supplierOrderLink: (
            <Link
              to={`/app/supplier-orders/${encodeURIComponent(taken.supplierOrderId)}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="supplier-order-number-taken-link"
            />
          ),
        }}
      />
    );
  }
  return <>{getSupplierOrderNumberTakenMessage(taken, t)}</>;
};

export default SupplierOrderNumberTakenHelp;
